import { ContentId } from './content-block';
import { FunctionalElement, FUNCTIONAL_ELEMENT_TYPE } from './functional-element';

export type DiscrepancyLog = Readonly<{
    id: ContentId;
    label: string;
    xmlId: string;
    value: string;
    type: FUNCTIONAL_ELEMENT_TYPE.DISCREPANCY_LOG;
}> &
    FunctionalElement;

export const initialDiscrepancyLogState: DiscrepancyLog = {
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.DISCREPANCY_LOG,
    id: -1,
    label: '',
    xmlId: '',
    value: '',
    controllingCheckpoint: '',
    disabled: false,
    contentLoadedFromXml: false,
    controllingOption: undefined,
};

export function isDiscrepancyLog(f: FunctionalElement): f is DiscrepancyLog {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.DISCREPANCY_LOG;
}
